<template>
    <div style="position: relative;"
         :style="{'font-family':item.font,'font-size':item.fontSize,'padding-top':sealMargin}">
        <div id="sign-line-1" style="height:0;width:1em;outline:none;border:none;padding:0;margin:0;">
            &nbsp;
        </div>
        <div id="sign-line-2" style="width:156mm;outline:none;border:none;padding:0;margin:0;">
            &nbsp;
        </div>
        <div :style="{'margin-left':orgOffsetWidth+'px'}" v-if="item.org">
            <div id="sign-org" v-for="(text,index) in item.org.split('\n')"
                  :key="index">
                {{text}}
            </div>
        </div>
        <div style="display: block" :style="{'margin-left':dateOffsetWidth+'px'}">
            <span id="sign-date" v-html="convert(item.date)"></span>
        </div>

        <div v-if="seal" style="position: absolute;bottom: -0.5em;" :style="{'margin-left':sealOffsetWidth+'px'}">
            <img ref="seal" :w="seal.width" :h="seal.height" :style="{height:seal.height+'px',width:seal.width+'px'}"
                 :src="sealURL"/>
        </div>
    </div>
</template>

<script>
    import envConfig from '../../../../config/';

    export default {
        name: "DocSign",
        props: {
            item: {},
            seal: {}
        },
        data() {
            return {
                sealData: null,
                emWidth: 0,
                lineHeight: 0,
                orgWidth: 0,
                orgHeight: 0,
                dateWidth: 0,
                dateHeight: 0,
                pageWidth: 0,
                dateOffsetWidth: 0,
                orgOffsetWidth: 0,
                sealOffsetWidth: 0,
                lastHash: ""
            }
        },
        mounted() {
            this.doUpdate();
        },

        updated() {
            this.$nextTick(() => {
                this.doUpdate();
            })
        },
        watch: {
            seal: {
                deep: true,
                handler() {
                    console.log('hanlder===>')
                    let canvasImg = new Image();
                    canvasImg.setAttribute('crossOrigin', 'anonymous');
                    let that=this;
                    canvasImg.onload = function () {
                        let canvas = document.createElement("canvas");
                        canvas.width = this.width;
                        canvas.height = this.height;
                        let ctx = canvas.getContext("2d");
                        ctx.drawImage(canvasImg, 0, 0);
                       // console.log("that==>"+that.sealData.data)
                        let dataURL = canvas.toDataURL("image/png");
                        that.$refs.seal.setAttribute("data-url",dataURL);
                       // console.log(that.$refs.seal)
                       // console.log(that.sealData.data);
                    }
                    canvasImg.src = this.sealURL;
                }
            }
        },
        computed: {
            sealMargin: function () {
                if (this.seal && this.seal.height > 0) {
                    return (this.seal.height - this.lineHeight * 3) + 'px'
                } else {
                    return (this.lineHeight - 5) + 'px';
                }
            },
            sealURL: function () {
                if (this.seal && this.seal.url) {
                    return envConfig.baseURL + this.seal.url;
                }
                return null;
            }
        },
        methods: {
            convert(content, appendId) {
                return this.$tool.text2Html(content, appendId, false, "span");
            },
            doUpdate() {
                let hash = this.$tool.hash(JSON.stringify({item: this.item, seal: this.seal}));
                if (hash == this.lastHash) {
                    return;
                }
                this.lastHash = hash;
                let ele = document.getElementById("sign-line-1");
                this.emWidth = ele.offsetWidth;
                ele = document.getElementById("sign-line-2");
                this.lineHeight = ele.offsetHeight;

                this.pageWidth = ele.offsetWidth;
                let eleOrg = document.getElementById("sign-org");
                let eleDate = document.getElementById("sign-date");
                if(!eleDate||!eleOrg){
                    return;
                }
                this.orgHeight = eleOrg.offsetHeight;
                this.orgWidth = eleOrg.offsetWidth;
                this.dateHeight = eleDate.offsetHeight;
                this.dateWidth = eleDate.offsetWidth;
                // console.log("---------------")
                // console.log(this.emWidth)
                // console.log(this.lineHeight)
                // console.log(this.orgHeight)
                // console.log(this.orgWidth)
                // console.log(this.dateHeight)
                // console.log(this.dateWidth)
                // console.log(this.pageWidth)
                // console.log("---------------")
                this.dateOffsetWidth = this.pageWidth - 4 * this.emWidth - this.dateWidth;
                // console.log('offsetwidth===>');
                // console.log(this.dateOffsetWidth);

                let m = this.pageWidth - (this.dateWidth + this.orgWidth) / 2 - 4 * this.emWidth;
                if (this.pageWidth - (m + this.orgWidth) < 2 * this.emWidth) {
                    m = this.pageWidth - 2 * this.emWidth - this.orgWidth;
                }
                this.orgOffsetWidth = m;
                if (this.seal) {
                    // console.log('sealWidth===>' + this.seal.width);
                    this.sealOffsetWidth = this.pageWidth - (this.dateWidth + this.seal.width) / 2 - 4 * this.emWidth;
                }


                let canvasImg = new Image();
                canvasImg.setAttribute('crossOrigin', 'anonymous');
                let that=this;
                canvasImg.onload = function () {
                    let canvas = document.createElement("canvas");
                    canvas.width = this.width;
                    canvas.height = this.height;
                    let ctx = canvas.getContext("2d");
                    ctx.drawImage(canvasImg, 0, 0);
                    let dataURL = canvas.toDataURL("image/png");
                    that.$refs.seal.setAttribute("data-url",dataURL);
                }
                canvasImg.src = this.sealURL;
            }
        }
    }
</script>